import React from 'react';
import { attachmentStatuses, companyTypes, counterpartyKind, formModes } from '../../constants';
import i18next from "../../i18n";
import { AttachmentsForm, getNewAttachmentId } from '../attachments/AttachmentsForm';
import { renderFormHeader } from '../document/DocumentHelpers';
import { documentTabs } from "../document/DocumentSettings";
import { checkCompanyRegisterCode, checkEmail, checkMFO, checkPersoneRegisterCode, checkPhone } from '../helpers/CheckFunctions';
import { transliterateString } from '../helpers/HelperFunctions';
import { Svg } from '../Svg';
import { getAttachmentIndicator } from './counterpartyAccreditationHelpers';
import { copyAddress } from './counterpartyAccreditationHelpers';
export { settings } from './counterpartyAccreditationHelpers';
export { getCurAttacmentsTypes } from './counterpartyAccreditationHelpers';
export { youControlRequest } from './counterpartyAccreditationHelpers';
export { getAttachmentConfiguration } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatoryAdding } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatorySigning } from './counterpartyAccreditationHelpers';
export { addSigner } from './counterpartyAccreditationHelpers';
export { addAttacment } from './counterpartyAccreditationHelpers';
export { buildFormItem } from './counterpartyAccreditationHelpers';
export { deleteSigners } from './counterpartyAccreditationHelpers';
export { deleteAccountant } from './counterpartyAccreditationHelpers';
export function checkInputPage() {
	this.incorrectFormat = false;
	let incorectTabs = Object.keys(documentTabs).map((key) => {
		if (!this.checkInputTab(documentTabs[key]))
			return documentTabs[key];
		else
			return null;
	}).filter(item => item);

	if (incorectTabs.length === 0) {
		incorectTabs = Object.keys(documentTabs).map((key) => {
			if (!this.checkInputTabFormat(documentTabs[key]))
				return documentTabs[key];
			else
				return null;
		}).filter(item => item);
		if (incorectTabs.length > 0) this.incorrectFormat = true;
	}
	this.incorectTabs = incorectTabs;
	if (incorectTabs.length > 0) {
		let currentTabPos = incorectTabs.indexOf(this.state.activeTab);
		if (currentTabPos > -1) {
			incorectTabs.splice(currentTabPos, 1);
			incorectTabs.unshift(this.state.activeTab);
		}
		return false;
	}
	return true;
}
export function checkInputTab(tabIndex) {
	const { prop_sxcfc_counterpartyType,
		prop_sxcfc_counterpartyKind,
		prop_sxcfc_counterpartyFullName,
		prop_sxcfc_codeEDRPOU,
		prop_sxcfc_codeIPN,
		prop_sxcfc_bankFullNameWithAddress,
		prop_sxcfc_MFO,
		prop_sxcfc_bankAccount,
		prop_sxcfc_taxationForm,
		prop_sxcfc_PDVPayer,
		prop_sxcfc_singleTaxPayer,
		prop_sxcfc_landOwned,
		prop_sxcfc_landRent,
		prop_sxcfc_employeesNumber,
		prop_sxcfc_counterpartyPhone,
		prop_sxcfc_counterpartyEmail,
		prop_sxcfc_counterpartyShortName,
		prop_sxcfc_index,
		prop_sxcfc_region,
		prop_sxcfc_city,
		prop_sxcfc_street,
		prop_sxcfc_building,
		prop_sxcfc_laIndex,
		prop_sxcfc_laRegion,
		prop_sxcfc_laCity,
		prop_sxcfc_laStreet,
		prop_sxcfc_laBuilding,
		signers } = this.state;
	let result = true;
	// eslint-disable-next-line default-case
	switch (tabIndex) {
		case documentTabs.information:
			result = !!(prop_sxcfc_counterpartyType && prop_sxcfc_counterpartyKind && prop_sxcfc_counterpartyFullName &&
				(prop_sxcfc_counterpartyType === companyTypes.Entity ? prop_sxcfc_codeEDRPOU : true) &&
				(prop_sxcfc_counterpartyType === companyTypes.Individual ? prop_sxcfc_codeIPN : true) &&
				prop_sxcfc_counterpartyShortName);
			break;
		case documentTabs.financialinfo:
			result = !!(prop_sxcfc_bankFullNameWithAddress && prop_sxcfc_MFO && prop_sxcfc_bankAccount && prop_sxcfc_taxationForm && (prop_sxcfc_PDVPayer !== undefined) && (prop_sxcfc_singleTaxPayer !== undefined) &&
				(prop_sxcfc_counterpartyKind !== counterpartyKind.Maker || (prop_sxcfc_landOwned && prop_sxcfc_landRent)) && prop_sxcfc_employeesNumber);
			break;
		case documentTabs.contactinfo:
			result = !!(prop_sxcfc_counterpartyPhone && prop_sxcfc_counterpartyEmail
				&& prop_sxcfc_index && prop_sxcfc_region && prop_sxcfc_city && prop_sxcfc_street && prop_sxcfc_building && prop_sxcfc_laIndex && prop_sxcfc_laRegion
				&& prop_sxcfc_laCity && prop_sxcfc_laStreet && prop_sxcfc_laBuilding);
			break;
		case documentTabs.signers:
			if (!signers || signers.length === 0) return false;
			break;
	}
	return result;
}
export function checkInputTabFormat(tabIndex) {
	const { prop_sxcfc_counterpartyType,
		prop_sxcfc_codeEDRPOU,
		prop_sxcfc_codeIPN,
		prop_sxcfc_MFO,
		prop_sxcfc_counterpartyPhone,
		prop_sxcfc_counterpartyEmail,
		prop_sxcfc_counterpartySecondPhone } = this.state;
	let result = true;
	// eslint-disable-next-line default-case
	switch (tabIndex) {
		case documentTabs.information:
			result = !!((prop_sxcfc_counterpartyType === companyTypes.Entity ? (!prop_sxcfc_codeEDRPOU || checkCompanyRegisterCode(prop_sxcfc_codeEDRPOU)) : true) &&
				(!prop_sxcfc_codeIPN || checkPersoneRegisterCode(prop_sxcfc_codeIPN, prop_sxcfc_counterpartyType)));
			break;
		case documentTabs.financialinfo:
			result = !!(!prop_sxcfc_MFO || checkMFO(prop_sxcfc_MFO));
			break;
		case documentTabs.contactinfo:
			result = !!(!prop_sxcfc_counterpartyPhone || checkPhone(prop_sxcfc_counterpartyPhone)
				&& (!prop_sxcfc_counterpartySecondPhone || checkPhone(prop_sxcfc_counterpartySecondPhone))
				&& (!prop_sxcfc_counterpartyEmail || checkEmail(prop_sxcfc_counterpartyEmail)));
			break;
	}
	return result;
}
export function navigateToIncorrectForm() {
	if (this.incorectTabs && this.incorectTabs.length > 0) {
		this.setState({ activeTab: this.incorectTabs[0] });
	}
}
export function transliterate() {
	this.setState({
		prop_sxcfc_counterpartyFullNameENG: transliterateString(this.state.prop_sxcfc_counterpartyFullName, false),
		prop_sxcfc_counterpartyShortNameENG: transliterateString(this.state.prop_sxcfc_counterpartyShortName, false)
	});
}

export function rendercontactinfo() {
	return (
		<div className="doc-form-block" key="contactInfoTab">
			{renderFormHeader.bind(this)()}
			<div className="form-block large-form doc-form">
				<div className="form-content">
					<div className="row">
						{this.buildFormSection("legalAddress")}
						<div className="form-group col-sm-12 col-xs-12">
							<label className="header-label">{i18next.t("mailingAddress")}</label>
							<div className="label-address-btn" onClick={copyAddress.bind(this)}>
								<Svg src="/img/refresh.svg" />
								<span>{i18next.t("fillFromLegalAddress")}</span>
							</div>
						</div>
						{this.buildFormSection("mailingAddress")}
						{this.buildFormSection("contacts")}
					</div>
					<div className="required-label"><label className="required" />{i18next.t("requiredFields")}</div>
				</div>
			</div>
		</div>
	);
}
export function renderfinancialinfo() {
	return (
		<div className="doc-form-block" key="financialInfoTab">
			{renderFormHeader.bind(this)()}
			<div className="form-block large-form doc-form">
				<div className="form-content">
					<div className="row">
						{this.buildFormSection("financialInformation")}
					</div>
					<div className="required-label"><label className="required" />{i18next.t("requiredFields")}</div>
				</div>
			</div>
		</div>
	);
}
export function renderinformation() {
	return (
		<div className="doc-form-block" key="informationTab">
			{renderFormHeader.bind(this)()}
			<div className="form-block large-form doc-form x">
				<div className="form-content">
					<div className="row">
						{this.buildFormSection("mainForm")}
					</div>
					<div className="required-label"><label className="required" />{i18next.t("requiredFields")}</div>
				</div>
			</div>
		</div>
	);
}
export function renderdocs() {
	const { attachments, formMode } = this.state;
	const attachmentsChangedCallback = function (attachments) {
		const { attachmentsTypes } = this.state;
		for (let i = 0; i < attachmentsTypes?.length; ++i) {
			if (attachments.findIndex(a => a.documentType === attachmentsTypes[i].value) < 0) {
				attachments.push({
					id: getNewAttachmentId(attachments),
					state: attachmentStatuses.NotAdded,
					documentType: attachmentsTypes[i].value
				});
			}
		}
		this.setState({ attachments: attachments });
	}
	return (
		<div className="doc-form-block" key="docsTab">
			{renderFormHeader.bind(this)()}
			<div className="large-form doc-form">
				{formModes.read !== formMode &&
					<div className="doc-form-info">
						<Svg src="/img/info.svg" />
						<div className="doc-form-info-text">{i18next.t("requestAttachmentsHelpText")}</div>
					</div>
				}
				<AttachmentsForm attachments={attachments} edite={formModes.read !== formMode} typesOfDocumens={this.getCurAttacmentsTypes()} getAttachmentIndicatorHandler={getAttachmentIndicator.bind(this)} changedCallback={attachmentsChangedCallback.bind(this)} />
			</div>
		</div>
	);
}